import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { TransportationRoleEnum } from "src/app/shared/generated/enum/transportation-role-enum";

@Injectable({ providedIn: "root" })
export class TransportationAdminAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const isTransportationAdmin = user?.TransportationRoleID === TransportationRoleEnum.Admin;
                if (!isTransportationAdmin) {
                    this.router.navigate(["/transportation"]);
                    return false;
                }
                return true;
            })
        );
    }
}
